<template lang="pug">
transition(:name="pageTransition")
	router-view(v-bind="passProps")
</template>

<script>
export default {
	props: {
		pageTransition: {
			type: String,
			default: "g_fade-grow"
		}
	},

	computed: {
		passProps() {
			let p = Object.assign({}, this.$props);
			delete p.pageTransition;
			return p;
		}
	},

	mounted() {
		// console.debug(this.pageTransition);
	}
};
</script>

<style lang="stylus"></style>
